<app-nav-item
  [item]="navItem"
  [count]="newsLength"
></app-nav-item>

@if (authenticated$ | async) {}
